import { ssrApi } from 'api/ssr';
import { Streamers } from 'components/template/streamers';
import { IStreamer } from 'constants/types';

export default function StreamersPage({
  streamers,
}: {
  streamers: IStreamer[];
}) {
  return <Streamers hideCollections streamers={streamers} />;
}

export async function getServerSideProps() {
  const { streamers } = await ssrApi.streamers.list({
    limit: 1000,
    sortBy: 'popular',
  });

  return {
    props: {
      streamers,
    },
  };
}
